// extracted by mini-css-extract-plugin
export default {"header":"MatchesDetailsTtp_header__TEch6"};